import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {from, map, Observable, of} from 'rxjs';
import {EmployeeBusinessService} from '../services/business.service';
import {USER_RULES} from './user-rules';
import { isPlatformBrowser } from '@angular/common';
import { RoutesConfig } from '@employee-configs/routes.config';

@Injectable({
    providedIn: 'root'
})
export class PhotoComplianceRequestPageGuard implements CanActivate {

    constructor(
        private businessService: EmployeeBusinessService,
        private router: Router
    ) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const currentUser = this.businessService.userProfileService.user;
        return of(true);
        //Allowing Access to only US people
        // if (!currentUser.isUSI) {
        //    return of(true);
        // }
        // else {
        //     return from(this.router.navigate([RoutesConfig.general.accessDeniedPage])).pipe( 
        //         map(() => false) // Convert the promise from navigate to an observable of false 
        //         ); 
        // }
    }

}
